import { createFileRoute, redirect } from '@tanstack/react-router';
import { createCaslRedirectGuard } from '@/lib/auth/permissionGuards';

const redirectWithoutOrgSettings = createCaslRedirectGuard('OrgSettings', [
  { subject: 'DataSync', action: 'update', to: '/$slug/organization-settings/data-sync' }
]);

export const Route = createFileRoute('/$slug/organization-settings/')({
  // A user with neither grant lands on settings, whose guard sends them home.
  beforeLoad: async (args) => {
    await redirectWithoutOrgSettings(args);
    throw redirect({
      to: '/$slug/organization-settings/settings',
      params: { slug: args.params.slug }
    });
  }
});
